const logoutUser = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem('fibraUserName');
    window.localStorage.removeItem('tkn');
    window.localStorage.removeItem('location');
  }
};

const setStorageTokens = ({ token, refreshToken }) => {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem('tkn', token);
  window.localStorage.setItem('refreshToken', refreshToken);
};

// eslint-disable-next-line import/prefer-default-export
export { logoutUser, setStorageTokens };
